import { render, staticRenderFns } from "./CmgOrderReward.vue?vue&type=template&id=bff4b6f8&scoped=true&lang=pug"
import script from "./cmg-order-reward.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-reward.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgOrderReward.vue?vue&type=style&index=0&id=bff4b6f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff4b6f8",
  null
  
)

export default component.exports